import {User}									from '../user/interface';
import {ApiSupportState}						from './interface';

import * as API									from '../../ressources/API';


export default {
	getSupportApi: async (user: User) => {
		const response = await API.getSupport(user);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	postSupportApi: async (data: ApiSupportState) => {
		if (!data.data.type)
			return null;

		const response = await API.postSupport(data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	closeSupportApi: async (data: ApiSupportState) => {
		if (!data.idSupport)
			return null;

		const response = await API.closeSupport(data.idSupport, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	noticeSupportApi: async (data: ApiSupportState) => {
		if (!data.idSupport)
			return null;

		const response = await API.noticeSupport(data.idSupport, data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	postSupportMessageApi: async (data: ApiSupportState) => {
		if (!data.idSupport)
			return null;

		const response = await API.postSupportMessages(data.idSupport, data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	}
};
